import React, {useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Accordion from "@material-ui/core/Accordion";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    answerState,
    menuCheckSelector,
    selectedMenuItemState,
    surveyDataState,
    userState
} from "../../state/globalState";

export const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#1b6817',
        },
    },
    textField: {
        width: '300px'
    },
    textFieldMobile: {
        width: '250px'
    },
    formControl: {
        margin: theme.spacing(0.5)
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    radioTextColor: {
        color: 'red'
    }
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey1 = (props) => {
    const userInfo = useRecoilValue(userState);
    const survey = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const matches = useMediaQuery('(max-width:600px)');
    const classes = useStyles();
    const agreeYn = answer.frorAgreeYn;
    const frorIndividual = answer.frorIndividual;
    const frorRlspCd = answer.frorRlspGcd;
    const frorJobTitle = answer.frorJobTitle;
    const frorCorpName = answer.frorCorpNm;
    const [selFror, setSelFror] = useState('1');
    const [fror, setFror] = useState([]);
    const [openSubQuestion, setOpenSubQuestion] = useState(agreeYn === "0");
    let parentCompRef = props.compRef;

    const addRefs = (el, idx) => {
        parentCompRef[idx] = el;
    };

    useEffect(() => {
        if (selFror === "1") {
            setFror([
                <span className='radioLabel'>본인이나 본인의 직계가족이 미국 증권거래위원회 상장회사의 재무제표의 내용이나 작성자에게 중대한 영향력을 행사할 수 있는 위치에 해당되지 않습니다.</span>,
                <span className='radioLabel'>미국 증권거래위원회 상장회사의 재무제표의 내용이나 작성자에게 중대한 영향력을 행사할 수 있는 위치에 해당됩니다(선택하시는 경우, 종합소득세 서비스 진행이 불가합니다. 다만, 회사와 정확한 정보확인을 위해 아래 추가정보를 기입해 주십시오.)</span>
            ]);
        } else {
            setFror([
                <span className='radioLabel'>본인이나 본인의 직계가족이 미국 증권거래위원회 상장회사의 재무제표의 내용이나 작성자에게 중대한 영향력을 행사할 수 있는 위치에 해당되지 않습니다.</span>,
                <span className='radioLabel'>미국 증권거래위원회 상장회사의 재무제표의 내용이나 작성자에게 중대한 영향력을 행사할 수 있는 위치에 해당됩니다<div style={{color: 'red'}}>(선택하시는 경우, 종합소득세 서비스 진행이 불가합니다. 다만, 회사와 정확한 정보확인을 위해 아래 추가정보를 기입해 주십시오.)</div></span>
            ]);
        }
    }, [selFror]);

    const handleInputAnswer = (e, column) => {
        const { value, name } = e.target;

        if ("frorAgreeYn" === column) {
            setSelFror(value);
            setSelectedMenuItem('SURVEY_0');
            setMenuCheck(value !== '');

            if (value === '1') {
                setOpenSubQuestion(false)
            } else {
                setOpenSubQuestion(true);
            }

        } else if ("frorIndividual" === column) {
            if (value.length > 50) {
                return;
            }
            setSelectedMenuItem('SURVEY_1');
            setMenuCheck(value !== '');
        } else if ("frorRlspGcd" === column) {
            setSelectedMenuItem('SURVEY_2');
            setMenuCheck(value !== '');
        } else if ("frorJobTitle" === column) {
            if (value.length > 50) {
                return;
            }
            setSelectedMenuItem('SURVEY_3');
            setMenuCheck(value !== '');
        } else if ("frorCorpNm" === column) {
            if (value.length > 50) {
                return;
            }
            setSelectedMenuItem('SURVEY_4');
            setMenuCheck(value !== '');
        }

        setAnswer({
            ...answer,
            [column]: value
        });
    };

    const StyledRadioAgreeYn = (props) => {
        return (
            <Radio
                key={'agree-' + props.key}
                disableRipple
                color="default"
                checked={agreeYn === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'frorAgreeYn')}
                {...props}
            />
        );
    };

    const StyledRadioFrorRlspCd = (props) => {
        return (
            <Radio
                key={'fror-' + props.key}
                disableRipple
                color="default"
                checked={frorRlspCd === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'frorRlspGcd')}
                {...props}
            />
        );
    };

    const step0List = survey[0].text.map((item, idx) => {
        // item.content = item.content.replace('$stdYear$', userInfo.stdYear);
        return (
            <>
                <FormControlLabel key={'0-' + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadioAgreeYn key='rd-agree'/>} label={fror[idx]}/>
            </>
        )
    });

    const step2List = survey[2].text.map((item) => {
        // item.content = item.content.replace('$stdYear$', userInfo.stdYear);

        return (
            <>
                <FormControlLabel key={'2-' + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadioFrorRlspCd key='rd-fror'/>} label={<span className="radioLabel">{item.content}</span>}/>
            </>
        )
    });

    const isDisplay = openSubQuestion === true ? 'block' : 'none';

    return (
        <>
            <ScrollableAnchor id={"0"}>
                <div>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <br /><br />
                        <SentenceForm
                            title={survey[0].title}
                            sentences={[]}
                            step={0}
                        />
                        <br/>
                        <Accordion style={{marginLeft: '20px', marginRight: '20px'}}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>감사법인의 독립성 규정에 따른 잠재적인 용역 제한</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography color="textSecondary">
                                    <h4>Potential Service Limitations Due to Independence Rules for Audit Firms</h4>
                                    <p>미국 증권거래위원회(SEC)가 제정한 Financial Reporting Oversight Role (FROR) 규정에 의하면 회계감사법인인 Ernst & Young과 고객사간 감사관계가 존재할 경우 개인에 대한 세무자문 서비스 제공이 금지될 수 있습니다.</p>
                                    <p>Financial Reporting Oversight Role (FROR) 규정은 미국에서 발효되었으나 수범 대상자에 해당 개인 뿐만 아니라 그 직계가족까지 포함되므로 전 세계에 영향을 미칠 수 있습니다. 따라서, 직계가족이 Ernst & Young에서 감사하는 미국 증권거래위원회(SEC) 상장회사의 중대한 역할을 수행할 가능성이 있으므로 FROR 규정은 미국과 직접적으로 연관이 없는 개인에 대해서도 적용될 수 있습니다.</p>
                                    <p>재무제표의 내용이나 재무제표 작성자에게 영향력을 행사할 수 있는 역할을 Financial Reporting Oversight Role (FROR)이라고 지칭합니다. 재무제표의 내용이나 재무제표 작성자에게 영향력을 행사할 수 있는 위치에 있는 사람의 예시는 다음과 같습니다.</p>
                                    <p>최고 경영자(CEO), 사장, 최고 재무담당책임자(CFO), 최고 업무집행책임자(COO), 고문 변호사, 최고 회계 책임자, 회계 담당자, 내부감사 책임자, 재무보고, 재무 및 세무 이사 또는 이와 동등한 지위 등이 FROR 에 해당됩니다. 또한 공개기업의 재무제표 및 미국 증권거래위원회 보고에 포함되어있는 관련 정보를 작성하는 사람들을 감독하는 직접적인 책임을 지는 개인도 FROR에 포함됩니다.</p>
                                    <p style={{fontStyle: 'normal', fontWeight: 'bold'}}>따라서 귀하 또는 귀하의 직계가족이 (직계가족은 귀하의 배우자 또는 그와 동등한 관계에 있는 사람과 부양가족을 의미함) 미국 증권거래위원회 상장회사의 재무제표의 내용이나 재무제표 작성자에게 영향력을 행사할 수 있는 위치에 있는지 확인하고자 하오니，만일 해당사항이 있다면 YES 박스를 체크하신 후 Summary Sheet 상의 정보를 기입하시기 바랍니다. 만약 귀하나 직계가족이 FROR에 해당하지 않으면 NO 박스를 체크하시고 Summary Sheet는 무시하시기 바랍니다.</p>
                                    <p>Ernst & Young 은 주기적으로 귀하와 귀하의 직계가족의 FROR 여부에 대해 확인을 요청드릴 것입니다. 위 내용을 확인하고 서명한 이후 귀하 또는 귀하의 직계가족의 직위변화로 인하여 FROR에 해당된다면, Ernst & Young 담당자에게 알려주시기 바랍니다.</p>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                        <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                            {/*<Divider />*/}
                            <RadioGroup defaultValue="0" aria-label="" name="">
                                {step0List}
                            </RadioGroup>
                            {/*<Divider />*/}
                        </FormControl>
                    </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"1"}>
                <div style={{display: isDisplay}}>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={survey[1].title}
                        sentences={survey[1].questions}
                        step={1}
                    />
                    <div className="textFieldContainer">
                        <TextField
                            key={'frorIndividual'}
                            className={matches ? classes.textFieldMobile : classes.textField}
                            label="여기에 답변을 입력하십시오."
                            placeholder=""
                            margin="none"
                            value={frorIndividual}
                            onChange={(e) => handleInputAnswer(e, 'frorIndividual')}
                            inputRef={(el) => addRefs(el, 1)}
                        />
                    </div>
                </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"2"}>
                <div style={{display: isDisplay}}>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={survey[2].title}
                        sentences={survey[2].questions}
                        step={2}
                    />
                    <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                        {/*<Divider />*/}
                        <RadioGroup defaultValue="0" aria-label="" name="" row>
                            {step2List}
                        </RadioGroup>
                        {/*<Divider />*/}
                    </FormControl>
                </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"3"}>
                <div style={{display: isDisplay}}>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={survey[3].title}
                        sentences={survey[3].questions}
                        step={3}
                    />
                    <div className="textFieldContainer">
                        <TextField
                            key={'frorJobTitle'}
                            className={matches ? classes.textFieldMobile : classes.textField}
                            label="여기에 답변을 입력하십시오."
                            placeholder=""
                            margin="none"
                            value={frorJobTitle}
                            onChange={(e) => handleInputAnswer(e, 'frorJobTitle')}
                            inputRef={(el) => addRefs(el, 3)}
                        />
                    </div>
                </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"4"}>
                <div style={{display: isDisplay}}>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={survey[4].title}
                        sentences={survey[4].questions}
                        step={4}
                    />
                    <div className="textFieldContainer">
                        <TextField
                            key={'frorCorpName'}
                            className={matches ? classes.textFieldMobile : classes.textField}
                            label="여기에 답변을 입력하십시오."
                            placeholder=""
                            margin="none"
                            value={frorCorpName}
                            onChange={(e) => handleInputAnswer(e, 'frorCorpNm')}
                            inputRef={(el) => addRefs(el, 4)}
                        />
                    </div>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey1;
